import { useTranslation } from "react-i18next";
import useViewDataObject from "../../../hooks/redux/useViewDataObject";
import { VIEW_TYPES } from "../../../config/view/types";
import React, { Fragment, useCallback } from "react";
import { buildFetchFileUrl, getContentManagementDataById } from "../../../axios/api/services";
import {
  CONTENT_MANAGEMENT_ID,
  fileExtensionByContentType,
  FileIconButton,
  HtmlParseText,
  removeExtension,
} from "@duosoftbg/nacid-components";
import PageWrapper from "../../components/common/layout/PageWrapper";
import styled from "styled-components";
import ViewPageWrapper from "../contacts/ViewPageWrapper";

const LawSectionLabel = styled.div`
  font-size: 0.95rem;
  color: #000;
  font-weight: 600;
`;

const LawSectionContent = styled.div`
  margin-left: 15px;
  margin-top: 10px;
`;

const LawSectionWrapper = styled.div`
  margin-bottom: 25px;
`;

const Law = () => {
  const { t } = useTranslation();

  const viewType = VIEW_TYPES.LAW;
  const { object, data: law } = useViewDataObject(viewType);
  const serviceFn = useCallback(getContentManagementDataById(CONTENT_MANAGEMENT_ID.LAW), []);

  return (
    <PageWrapper title={t("t.page.law")}>
      <ViewPageWrapper viewType={viewType} serviceFn={serviceFn} object={object}>
        {law && (
          <Fragment>
            <LawSectionWrapper>
              <LawSectionLabel>{t("l.detail.info")}</LawSectionLabel>
              <LawSectionContent>
                <HtmlParseText text={law.description} styleArray={{ pointerEvents: "none" }} />
              </LawSectionContent>
            </LawSectionWrapper>

            <LawSectionWrapper>
              <LawSectionLabel>{t("l.detail.regulations")}</LawSectionLabel>
              {law.files.map((document) => (
                <LawSectionContent key={"law-section-content" + document.fileId}>
                  <FileIconButton
                    key={"file-icon-button" + document.fileId}
                    position={"absolute"}
                    type={fileExtensionByContentType(document.contentType)}
                    fileHref={buildFetchFileUrl(document.relativePath, document.fileId, document.rootDirectory)}
                    text={removeExtension(document.fileName)}
                  ></FileIconButton>
                </LawSectionContent>
              ))}
            </LawSectionWrapper>
          </Fragment>
        )}
      </ViewPageWrapper>
    </PageWrapper>
  );
};

export default Law;
